/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  MenstrualCycleResponseDto,
  MenstrualCycleUpsertRequestDto,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    MenstrualCycleResponseDtoFromJSON,
    MenstrualCycleResponseDtoToJSON,
    MenstrualCycleUpsertRequestDtoFromJSON,
    MenstrualCycleUpsertRequestDtoToJSON,
} from '../models/index';

export interface UpsertMenstrualCycleRequest {
    menstrualCycleUpsertRequestDto: MenstrualCycleUpsertRequestDto;
}

/**
 * 
 */
export class PatientMenstrualCycleApi extends runtime.BaseAPI {

    /**
     * Get patient\'s menstrual cycle
     */
    async getMenstrualCycleRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MenstrualCycleResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/menstrual-cycle`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MenstrualCycleResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get patient\'s menstrual cycle
     */
    async getMenstrualCycle(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MenstrualCycleResponseDto> {
        const response = await this.getMenstrualCycleRaw(initOverrides);
        return await response.value();
    }

    /**
     * Update patient\'s menstrual cycle
     */
    async upsertMenstrualCycleRaw(requestParameters: UpsertMenstrualCycleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MenstrualCycleResponseDto>> {
        if (requestParameters['menstrualCycleUpsertRequestDto'] == null) {
            throw new runtime.RequiredError(
                'menstrualCycleUpsertRequestDto',
                'Required parameter "menstrualCycleUpsertRequestDto" was null or undefined when calling upsertMenstrualCycle().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/menstrual-cycle`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MenstrualCycleUpsertRequestDtoToJSON(requestParameters['menstrualCycleUpsertRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MenstrualCycleResponseDtoFromJSON(jsonValue));
    }

    /**
     * Update patient\'s menstrual cycle
     */
    async upsertMenstrualCycle(requestParameters: UpsertMenstrualCycleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MenstrualCycleResponseDto> {
        const response = await this.upsertMenstrualCycleRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
